<template>
    <v-container fluid class="grey lighten-4 pb-12">
        <v-row class="justify-center">
            <v-col cols="12" md="9">
                <v-img
                    :src="getImg(logo)"
                    width="100"
                    class="mx-auto"
                ></v-img>
            </v-col>
        </v-row>
        <v-row class="justify-center text-center">
            <v-col cols="12" md="9" class="">
                <h2 class="black--text display-1 font-weight-bold" v-html="titulo"></h2>
                <div
                    class="pt-5 pb-3 subtitle-1 font-weight-regular text-uppercase" 
                    v-html="subtitulo"></div>
                <a :href="url">
                    <v-img
                        :src="getImg(imagem)"
                        max-width="500"
                        class="mx-auto"
                    />
                </a>
                <v-btn
                    x-large
                    color="primary"
                    class="mt-6 title"
                    :href="url"
                >
                    {{cta}}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        logo: 'logo.png',
        titulo: 'Em poucos minutos você receberá um e-mail com o conteúdo que prometemos.',
        subtitulo: 'Enquanto isso, veja esse vídeo que preparei para você com tanto carinho! ❤',
        imagem: 'typ.jpg',
        cta: 'Assistir Vídeo!',
        url: 'https://www.youtube.com/watch?v=mjzA_x9u6ws'
    }),
    methods: {
        getImg(i) {
            return require('../assets/img/'+i)
        },
    }
}
</script>